(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aurora-404"] && !Shopify.designMode) return;
  try {
    
  const A4_VERT = `#version 300 es
  in vec2 aPos;
  void main() { gl_Position = vec4(aPos, 0.0, 1.0); }`;

  const A4_FRAG = `#version 300 es
  precision highp float;
  uniform float uTime;
  uniform vec2 uRes;
  uniform vec3 uC0;
  uniform vec3 uC1;
  uniform vec3 uC2;
  uniform float uBlend;
  uniform float uAmp;
  uniform float uFreq;
  out vec4 fragColor;

  float band(float x, float t) {
    float v = 0.0;
    v += sin(x * 2.1 + t * 0.70) * 0.50;
    v += sin(x * 3.7 - t * 0.45) * 0.30;
    v += sin(x * 6.3 + t * 1.10) * 0.15;
    v += sin(x * 9.1 - t * 0.80) * 0.08;
    return v;
  }

  void main() {
    vec2 uv = gl_FragCoord.xy / uRes;

    vec3 ramp = uv.x < 0.5
      ? mix(uC0, uC1, uv.x * 2.0)
      : mix(uC1, uC2, (uv.x - 0.5) * 2.0);

    float h = band(uv.x * uFreq, uTime) * 0.25 * uAmp;
    h = exp(h);

    float f = uv.y * 2.0 - h + 0.2;
    float intensity = 0.6 * f;

    float mid = 0.20;
    float a = smoothstep(mid - uBlend * 0.5, mid + uBlend * 0.5, intensity);

    fragColor = vec4(ramp * clamp(intensity, 0.0, 1.4), a);
  }`;

  class AuroraHero extends HTMLElement {
    connectedCallback() {
      this.host = this.querySelector('[data-aurora-canvas]');
      if (!this.host) return;

      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.mq = window.matchMedia('(max-width: 749px)');

      this.speed = this.num('speed', 0.5);
      this.blend = this.num('blend', 0.5);
      this.amp = this.num('amp', 1);
      this.ampMobile = this.num('ampMobile', 0.6);
      this.stretchFix = this.dataset.stretchFix !== 'false';

      this.tick = this.tick.bind(this);
      this.resize = this.resize.bind(this);

      if (!this.init()) return;

      this.setAttribute('data-gl', 'on');
      this.resize();
      this.ro = new ResizeObserver(this.resize);
      this.ro.observe(this);

      this.draw(0);
      if (this.reduced) return;

      this.io = new IntersectionObserver(
        e => {
          if (e[0].isIntersecting) this.start();
          else this.stop();
        },
        { rootMargin: '100px' }
      );
      this.io.observe(this);
    }

    disconnectedCallback() {
      this.stop();
      if (this.io) this.io.disconnect();
      if (this.ro) this.ro.disconnect();
      if (this.gl) {
        const ext = this.gl.getExtension('WEBGL_lose_context');
        if (ext) ext.loseContext();
      }
    }

    num(key, fallback) {
      const v = parseFloat(this.dataset[key]);
      return Number.isFinite(v) ? v : fallback;
    }

    /* Amplitude for the current breakpoint */
    currentAmp() {
      return this.mq.matches ? this.ampMobile : this.amp;
    }

    /* The wave runs across uv.x, which is normalised to canvas width.
       On a narrow canvas the same wave count squeezes into less width and
       reads as vertically stretched, so scale frequency by aspect ratio,
       normalised against a typical desktop shape. */
    currentFreq() {
      if (!this.stretchFix) return 3.0;
      const w = this.canvas ? this.canvas.width : 1;
      const h = this.canvas ? this.canvas.height : 1;
      const aspect = w / Math.max(1, h);
      return 3.0 * Math.min(1.4, Math.max(0.45, aspect / 2.3));
    }

    compile(gl, type, src) {
      const sh = gl.createShader(type);
      gl.shaderSource(sh, src);
      gl.compileShader(sh);
      if (!gl.getShaderParameter(sh, gl.COMPILE_STATUS)) {
        console.warn('[aurora] shader failed:', gl.getShaderInfoLog(sh));
        return null;
      }
      return sh;
    }

    init() {
      const canvas = document.createElement('canvas');
      const gl = canvas.getContext('webgl2', {
        alpha: true,
        antialias: true,
        premultipliedAlpha: false
      });
      if (!gl) return false;

      const vs = this.compile(gl, gl.VERTEX_SHADER, A4_VERT);
      const fs = this.compile(gl, gl.FRAGMENT_SHADER, A4_FRAG);
      if (!vs || !fs) return false;

      const prog = gl.createProgram();
      gl.attachShader(prog, vs);
      gl.attachShader(prog, fs);
      gl.linkProgram(prog);
      if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) {
        console.warn('[aurora] link failed:', gl.getProgramInfoLog(prog));
        return false;
      }

      gl.useProgram(prog);

      const buf = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buf);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
      const loc = gl.getAttribLocation(prog, 'aPos');
      gl.enableVertexAttribArray(loc);
      gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);

      gl.enable(gl.BLEND);
      gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
      gl.clearColor(0, 0, 0, 0);

      this.u = {
        time: gl.getUniformLocation(prog, 'uTime'),
        res: gl.getUniformLocation(prog, 'uRes'),
        c0: gl.getUniformLocation(prog, 'uC0'),
        c1: gl.getUniformLocation(prog, 'uC1'),
        c2: gl.getUniformLocation(prog, 'uC2'),
        blend: gl.getUniformLocation(prog, 'uBlend'),
        amp: gl.getUniformLocation(prog, 'uAmp'),
        freq: gl.getUniformLocation(prog, 'uFreq')
      };

      gl.uniform3fv(this.u.c0, this.hex(this.dataset.c0, 'f43f5e'));
      gl.uniform3fv(this.u.c1, this.hex(this.dataset.c1, 'f97316'));
      gl.uniform3fv(this.u.c2, this.hex(this.dataset.c2, '5227ff'));
      gl.uniform1f(this.u.blend, this.blend);
      gl.uniform1f(this.u.amp, this.currentAmp());
      gl.uniform1f(this.u.freq, 3.0);

      this.canvas = canvas;
      this.gl = gl;
      this.host.appendChild(canvas);
      return true;
    }

    hex(v, fallback) {
      let h = (v || '').trim().replace('#', '');
      if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
      if (!/^[0-9a-fA-F]{6}$/.test(h)) h = fallback;
      const n = parseInt(h, 16);
      return [((n >> 16) & 255) / 255, ((n >> 8) & 255) / 255, (n & 255) / 255];
    }

    resize() {
      if (!this.gl) return;
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const w = Math.max(1, Math.round(this.offsetWidth * dpr));
      const h = Math.max(1, Math.round(this.offsetHeight * dpr));
      if (this.canvas.width === w && this.canvas.height === h) return;
      this.canvas.width = w;
      this.canvas.height = h;
      this.gl.viewport(0, 0, w, h);
      this.gl.uniform2f(this.u.res, w, h);
      this.gl.uniform1f(this.u.amp, this.currentAmp());
      this.gl.uniform1f(this.u.freq, this.currentFreq());
      this.draw(this.lastT || 0);
    }

    draw(t) {
      const gl = this.gl;
      if (!gl) return;
      this.lastT = t;
      gl.uniform1f(this.u.time, t);
      gl.clear(gl.COLOR_BUFFER_BIT);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
    }

    start() {
      if (this.raf) return;
      this.t0 = performance.now();
      this.raf = requestAnimationFrame(this.tick);
    }

    stop() {
      if (!this.raf) return;
      cancelAnimationFrame(this.raf);
      this.raf = null;
    }

    tick(now) {
      this.draw(((now - this.t0) / 1000) * this.speed);
      this.raf = requestAnimationFrame(this.tick);
    }
  }

  if (!customElements.get('aurora-hero')) {
    customElements.define('aurora-hero', AuroraHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-access"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('brand-access')) return;

    class BrandAccess extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.tabs = [...this.querySelectorAll('[data-ba-tab]')];
        this.panels = [...this.querySelectorAll('[data-ba-panel]')];
        this.ctas = [...this.querySelectorAll('[data-ba-cta]')];
        this.stage = this.querySelector('.ba__stage');
        this.heading = this.querySelector('.ba__heading');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.show(tab.dataset.baTab));
          /* Arrow keys move between the two, like a tab list. */
          tab.addEventListener('keydown', (e) => {
            if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
            e.preventDefault();
            const step = e.key === 'ArrowRight' ? 1 : -1;
            const next = this.tabs[(i + step + this.tabs.length) % this.tabs.length];
            next.focus();
            this.show(next.dataset.baTab);
          });
        });

        /* Phones: the brand name stays on one line and shrinks to the width
           of the title column. Refit when that width changes and when the
           web fonts arrive. */
        if (this.heading) {
          this.fitBrand();
          this.fitWidth = this.heading.clientWidth;
          this.fitRO = new ResizeObserver(() => {
            const w = this.heading.clientWidth;
            if (w === this.fitWidth) return;
            this.fitWidth = w;
            this.fitBrand();
          });
          this.fitRO.observe(this.heading);
          document.fonts?.ready.then(() => this.fitBrand());
        }
      }

      disconnectedCallback() {
        this.fitRO?.disconnect();
      }

      fitBrand() {
        if (!window.baFitBrand) window.baFitBrand = function(h){var b=h&&h.querySelector('.ba__brand');if(!b)return;b.style.fontSize='';if(!window.matchMedia('(max-width: 749px)').matches)return;var a=h.clientWidth,n=b.scrollWidth;if(n>a+0.5){var f=parseFloat(getComputedStyle(b).fontSize);b.style.fontSize=Math.max(12,Math.floor(f*a/n*4)/4)+'px';}};
        window.baFitBrand(this.heading);
      }

      show(key) {
        const tab = this.tabs.find((t) => t.dataset.baTab === key);
        if (!tab || tab.getAttribute('aria-pressed') === 'true') return;

        const stage = this.stage;
        const from = stage ? stage.offsetHeight : 0;

        this.tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        this.panels.forEach((panel) => {
          const on = panel.dataset.baPanel === key;
          panel.inert = !on;
          if (on && !this.reduced) {
            panel.classList.add('is-entering');
            panel.classList.add('is-active');
            requestAnimationFrame(() => requestAnimationFrame(() => panel.classList.remove('is-entering')));
          } else {
            panel.classList.toggle('is-active', on);
          }
        });

        /* Ease the grid area to the new department's height. */
        if (stage && !this.reduced) {
          stage.classList.remove('is-resizing');
          stage.style.height = '';
          const to = stage.offsetHeight;
          if (Math.abs(to - from) > 1) {
            stage.style.height = `${from}px`;
            void stage.offsetHeight;
            stage.classList.add('is-resizing');
            stage.style.height = `${to}px`;
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => {
              stage.classList.remove('is-resizing');
              stage.style.height = '';
            }, 560);
          }
        }

        if (tab.dataset.url) {
          this.ctas.forEach((cta) => {
            cta.href = tab.dataset.url;
            if (tab.dataset.ctaLabel) cta.setAttribute('aria-label', tab.dataset.ctaLabel);
          });
        }
      }
    }

    customElements.define('brand-access', BrandAccess);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-accordion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('category-accordion')) return;

    const clamp = (v, lo, hi) => Math.min(Math.max(v, lo), hi);

    class CategoryAccordion extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.mobile = window.matchMedia('(max-width: 749px)');
        this.lists = Array.from(this.querySelectorAll('.cag__list'));
        this.tabs = Array.from(this.querySelectorAll('.cag__tab'));
        this.ratio = clamp((parseFloat(this.dataset.ratio) || 52) / 100, 0.2, 0.9);
        this.parallax = clamp((parseFloat(this.dataset.parallax) || 0) / 100, 0, 1);
        this.hover = this.dataset.trigger !== 'click';
        const open = Math.max(1, parseInt(this.dataset.open, 10) || 1) - 1;

        this.lists.forEach((list) => {
          const items = Array.from(list.querySelectorAll('.cag__item'));
          list._items = items;
          list._active = Math.min(open, items.length - 1);
          list._media = 0;

          items.forEach((item, i) => {
            item.style.setProperty('--cag-i', String(i));
            const fx = parseFloat(item.dataset.fx);
            const fy = parseFloat(item.dataset.fy);
            item._fx = Number.isFinite(fx) ? clamp(fx, 0, 1) : 0.5;
            item._fy = Number.isFinite(fy) ? clamp(fy, 0, 1) : 0.5;
            const panel = item.querySelector('.cag__panel');
            if (!panel) return;

            panel.addEventListener('pointerenter', (e) => {
              if (this.hover && e.pointerType === 'mouse') this.activate(list, i);
            });

            // Keyboard focus only. A tap or a click also focuses the link, and
            // opening the panel there would let the click that follows go
            // straight through to the link.
            panel.addEventListener('focus', () => {
              let keyboard = true;
              try {
                keyboard = panel.matches(':focus-visible');
              } catch (err) {}
              if (keyboard) this.activate(list, i);
            });

            // A closed panel opens on the first tap or click; the link is only
            // followed once it is open.
            panel.addEventListener('click', (e) => {
              if (i !== list._active) {
                e.preventDefault();
                this.activate(list, i);
              }
            });

            panel.addEventListener('keydown', (e) => {
              const fwd = e.key === 'ArrowRight' || e.key === 'ArrowDown';
              const back = e.key === 'ArrowLeft' || e.key === 'ArrowUp';
              if (!fwd && !back) return;
              e.preventDefault();
              const next = (i + (fwd ? 1 : -1) + items.length) % items.length;
              items[next].querySelector('.cag__panel')?.focus();
            });
          });

          this.layout(list);
        });

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.show(tab.dataset.dept));
        });

        this.ro = new ResizeObserver(() => this.measureAll());
        this.ro.observe(this);
        this.onMedia = () => this.measureAll();
        this.mobile.addEventListener?.('change', this.onMedia);

        this.measureAll();
        // Transitions only after the first layout is painted.
        requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-ready')));
      }

      disconnectedCallback() {
        this.ro?.disconnect();
        this.mobile?.removeEventListener?.('change', this.onMedia);
      }

      show(dept) {
        const current = this.lists.find((l) => !l.hidden);
        if (current && current.dataset.dept === dept) return;

        this.tabs.forEach((t) => t.setAttribute('aria-pressed', String(t.dataset.dept === dept)));
        this.lists.forEach((list) => {
          const on = list.dataset.dept === dept;
          if (on) list.classList.add('is-entering');
          list.hidden = !on;
        });
        this.measureAll();

        // One frame with the start state painted, then let it rise in.
        const next = this.lists.find((l) => !l.hidden);
        if (next) {
          next.getBoundingClientRect();
          requestAnimationFrame(() => requestAnimationFrame(() => next.classList.remove('is-entering')));
        }
      }

      activate(list, i) {
        if (list._active === i) return;
        list._active = i;
        this.layout(list);
      }

      measureAll() {
        const vertical = this.mobile.matches;
        const gap = parseFloat(getComputedStyle(this).getPropertyValue('--cag-gap')) || 0;
        this.lists.forEach((list) => {
          if (list.hidden) return;
          const rect = list.getBoundingClientRect();
          const total = vertical ? rect.height : rect.width;
          if (!total) return;
          const n = list._items.length;
          const usable = Math.max(total - gap * (n - 1), 120);
          const size = Math.max(140, usable * this.ratio * 1.22);
          list._media = size;
          list._usable = usable;
          list.style.setProperty('--cag-media', `${Math.round(size)}px`);
          this.layout(list);
        });
      }

      layout(list) {
        const items = list._items;
        const n = items.length;
        const a = list._active;
        const grow = n > 1 ? (this.ratio * (n - 1)) / (1 - this.ratio) : 1;
        list.style.setProperty('--cag-grow', grow.toFixed(3));

        const media = list._media || 0;
        const usable = list._usable || 0;
        const vertical = this.mobile.matches;

        items.forEach((item, i) => {
          const on = i === a;
          item.classList.toggle('is-active', on);
          item.style.setProperty('--cag-side', on ? '0' : i < a ? '1' : '-1');
          const drift = clamp(a - i, -1.5, 1.5);
          let shift = on ? 0 : drift * this.parallax * (media || 320) * 0.06;

          // Focal point (06/10). The image box is `media` wide and centred on
          // the panel; with object-position set to the focal point, the focal
          // point sits at f * media inside the box. Sliding the box by
          // -(f - 0.5) * media puts it in the middle of the panel. The slide
          // is capped at the room between box and panel - worked out for the
          // size the panel is heading to, open or closed - so the edge of the
          // photo never shows. The parallax drift rides on top, inside the
          // same cap.
          if (media && usable) {
            const panel = n > 1 ? (on ? usable * this.ratio : (usable * (1 - this.ratio)) / (n - 1)) : usable;
            const f = vertical ? item._fy : item._fx;
            const room = Math.max(0, (media - panel) / 2);
            shift = clamp(shift - (f - 0.5) * media, -room, room);
          }

          item.style.setProperty('--cag-shift', `${shift.toFixed(1)}px`);
        });
      }
    }

    customElements.define('category-accordion', CategoryAccordion);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["daily-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('daily-hero')) return;

    class DailyHero extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.imgs = Array.from(this.querySelectorAll('.dh__img'));
        this.slides = Array.from(this.querySelectorAll('.dh__slide'));
        this.tabs = Array.from(this.querySelectorAll('.dh__tab'));
        this.pauseBtn = this.querySelector('.dh__pause');
        this.count = this.slides.length;
        this.current = 0;

        this.alignNames();
        document.fonts?.ready.then(() => this.alignNames());
        this.onResize = () => this.alignNames();
        window.addEventListener('resize', this.onResize, { passive: true });

        if (this.count < 2) return;

        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = !reduced && (parseFloat(this.dataset.autoplay) || 0) > 0;
        if (!this.autoplay) {
          this.dataset.autoplay = '0';
          this.pauseBtn?.remove();
        }

        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => {
            this.go(i);
          });
          // The progress line finishing is the clock: no separate timer that
          // could drift from what the line shows.
          tab.addEventListener('animationend', (e) => {
            if (e.animationName === 'dh-progress' && i === this.current) this.go((i + 1) % this.count);
          });
        });

        this.pauseBtn?.addEventListener('click', () => {
          this.stopped = !this.stopped;
          this.classList.toggle('is-stopped', this.stopped);
          this.pauseBtn.setAttribute('aria-label', this.stopped ? this.pauseBtn.dataset.labelPlay : this.pauseBtn.dataset.labelPause);
          this.sync();
        });

        // Pause while someone is reading or choosing.
        this.addEventListener('pointerenter', (e) => {
          if (e.pointerType === 'mouse') {
            this.hovered = true;
            this.sync();
          }
        });
        this.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.sync();
        });
        this.addEventListener('focusin', () => {
          this.focused = true;
          this.sync();
        });
        this.addEventListener('focusout', (e) => {
          if (!this.contains(e.relatedTarget)) {
            this.focused = false;
            this.sync();
          }
        });

        // And while nobody can see it.
        this.io = new IntersectionObserver(([entry]) => {
          this.offscreen = !entry.isIntersecting;
          this.sync();
        }, { threshold: 0.25 });
        this.io.observe(this);
        this.onVis = () => this.sync();
        document.addEventListener('visibilitychange', this.onVis);
      }

      disconnectedCallback() {
        this.io?.disconnect();
        if (this.onVis) document.removeEventListener('visibilitychange', this.onVis);
        if (this.onResize) window.removeEventListener('resize', this.onResize);
      }

      /* Optical left edge (29/09). A letter's ink does not start where its
         box starts: at 107px a Jost "P" begins 8px in, a "G" 4px, while the
         14px season line above begins 1px in. So "Pucci" looked indented
         against its season and against the buttons. CSS has no way to trim
         that side bearing, and it differs per first letter, so the first
         glyph of each name is measured on a canvas and the name is pulled
         left by the difference with the line above it. Re-run on resize,
         since the name scales with the viewport. */
      alignNames() {
        const ctx = (DailyHero.ctx ||= document.createElement('canvas').getContext('2d'));
        const inkStart = (el) => {
          const text = el.textContent.trim();
          if (!text) return 0;
          const cs = getComputedStyle(el);
          ctx.font = `${cs.fontStyle} ${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`;
          return -ctx.measureText(text[0]).actualBoundingBoxLeft;
        };
        for (const slide of this.slides) {
          const name = slide.querySelector('.dh__name');
          if (!name) continue;
          const line = slide.querySelector('.dh__eyebrow');
          const shift = inkStart(name) - (line ? inkStart(line) : 0);
          name.style.marginInlineStart = shift > 0.5 ? `${(-shift).toFixed(2)}px` : '';
        }
      }

      sync() {
        const paused = this.stopped || this.hovered || this.focused || this.offscreen || document.hidden;
        this.classList.toggle('is-paused', Boolean(paused));
      }

      go(i) {
        if (i === this.current) return;
        this.current = i;

        this.imgs.forEach((el, n) => el.classList.toggle('is-active', n === i));
        this.slides.forEach((el, n) => {
          const on = n === i;
          el.classList.toggle('is-active', on);
          el.inert = !on;
          if (on) el.removeAttribute('aria-hidden');
          else el.setAttribute('aria-hidden', 'true');
        });
        this.tabs.forEach((el, n) => {
          const on = n === i;
          el.classList.toggle('is-active', on);
          el.setAttribute('aria-pressed', String(on));
          if (on && el.parentElement) {
            // Keep the chosen name in view on a phone, sideways only.
            const row = el.parentElement;
            const left = el.offsetLeft - row.offsetLeft;
            if (left < row.scrollLeft || left + el.offsetWidth > row.scrollLeft + row.clientWidth) {
              row.scrollTo({ left: Math.max(0, left - 16), behavior: 'smooth' });
            }
          }
        });

        // A photo that was lazy and never shown yet: load it now.
        const img = this.imgs[i]?.querySelector('img');
        if (img && img.loading === 'lazy') img.loading = 'eager';

        // Restart the settle animation on the incoming photo.
        if (img) {
          img.style.animation = 'none';
          img.getBoundingClientRect();
          img.style.animation = '';
        }
      }
    }

    customElements.define('daily-hero', DailyHero);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["designer-index"] && !Shopify.designMode) return;
  try {
    
  class DesignerIndex extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.dsg__item'));
      this.groups = Array.from(this.querySelectorAll('.dsg__group'));
      this.letters = Array.from(this.querySelectorAll('.dsg__letter[data-letter]'));
      this.empty = this.querySelector('.dsg__empty');
      this.search = this.querySelector('.dsg__search');
      this.input = this.querySelector('.dsg__search-input');

      if (!this.items.length) return;

      // The bar's height decides where an anchor has to stop. It changes with
      // the viewport (it wraps on a narrow desktop) so it is watched, not read
      // once. Zero when the bar does not follow the page down.
      const bar = this.querySelector('.dsg__az--sticky');
      if (bar && 'ResizeObserver' in window) {
        const sync = () => this.style.setProperty('--dsg-az-h', Math.round(bar.getBoundingClientRect().height) + 'px');
        sync();
        new ResizeObserver(sync).observe(bar);
      } else if (!bar) {
        this.style.setProperty('--dsg-az-h', '0px');
      }

      // Accents folded once per name, so typing "chloe" finds "Chloé".
      this.items.forEach((item) => {
        item.dataset.key = DesignerIndex.fold(item.dataset.name || item.textContent);
      });

      if (!this.input) return;

      // The field is hidden in the markup: without this script it would be a
      // box that does nothing.
      if (this.search) this.search.hidden = false;

      this.filter = this.filter.bind(this);
      this.input.addEventListener('input', this.filter);
      this.input.addEventListener('search', this.filter);
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.input.value = '';
          this.filter();
        }
      });
    }

    static fold(value) {
      return (value || '')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .trim();
    }

    filter() {
      const query = DesignerIndex.fold(this.input.value);
      let shown = 0;

      this.items.forEach((item) => {
        const match = !query || item.dataset.key.includes(query);
        item.hidden = !match;
        if (match) shown += 1;
      });

      // A letter with nothing left under it goes away, and so does its link in
      // the bar - a jump to an empty group reads as a broken page.
      const alive = new Set();
      this.groups.forEach((group) => {
        const has = group.querySelector('.dsg__item:not([hidden])') !== null;
        group.hidden = !has;
        if (has) alive.add(group.dataset.letter);
      });

      this.letters.forEach((letter) => {
        letter.classList.toggle('dsg__letter--off', !alive.has(letter.dataset.letter));
      });

      if (this.empty) {
        this.empty.textContent = shown === 0 ? this.dataset.emptyText || '' : '';
        this.empty.hidden = shown !== 0;
      }
    }
  }

  if (!customElements.get('designer-index')) {
    customElements.define('designer-index', DesignerIndex);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["designer-wall"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('designer-wall')) return;

    class DesignerWall extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.grid = this.querySelector('.dsw__grid');
        if (!this.grid) return;
        this.items = [...this.grid.querySelectorAll('.dsw__item')];
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.classList.add('is-masonry');
        this.layout();
        this.ro = new ResizeObserver(() => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => {
            this.raf = 0;
            this.layout();
          });
        });
        this.ro.observe(this.grid);
        /* Transitions on position only after the first layout, so the
           tiles do not fly in from the corner on load. */
        requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-laid')));

        this.setupEntrance();
      }

      disconnectedCallback() {
        this.ro?.disconnect();
        this.io?.disconnect();
      }

      /* Each tile goes into the shortest column; heights come from the tile
         shape (data-ratio = height / width). */
      layout() {
        const cs = getComputedStyle(this);
        const cols = Math.max(1, parseInt(cs.getPropertyValue('--dsw-cols'), 10) || 2);
        const gap = parseFloat(getComputedStyle(this.grid).columnGap) || 0;
        const gcs = getComputedStyle(this.grid);
        const inner = this.grid.clientWidth - parseFloat(gcs.paddingLeft) - parseFloat(gcs.paddingRight);
        if (inner <= 0) return;
        const colW = (inner - gap * (cols - 1)) / cols;
        const heights = new Array(cols).fill(0);

        for (const item of this.items) {
          const ratio = parseFloat(item.dataset.ratio) || 1;
          const h = Math.round(colW * ratio);
          const col = heights.indexOf(Math.min(...heights));
          const x = col * (colW + gap);
          const y = heights[col];
          item.style.width = `${colW}px`;
          item.style.height = `${h}px`;
          item.style.transform = `translate(${x}px, ${y}px)`;
          heights[col] += h + gap;
        }
        this.grid.style.height = `${Math.max(0, Math.max(...heights) - gap)}px`;
      }

      /* The tiles rise in when the wall comes into view. If it is already
         on screen when the page opens, nothing is hidden. */
      setupEntrance() {
        if (this.reduced || !('IntersectionObserver' in window)) return;
        const r = this.grid.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.9) return;
        this.classList.add('is-armed');
        this.io = new IntersectionObserver(
          (entries) => {
            if (!entries.some((e) => e.isIntersecting)) return;
            this.io.disconnect();
            this.classList.add('is-entering');
            requestAnimationFrame(() => requestAnimationFrame(() => this.classList.remove('is-armed')));
          },
          { threshold: 0.12 }
        );
        this.io.observe(this.grid);
      }
    }

    customElements.define('designer-wall', DesignerWall);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drift-wall"] && !Shopify.designMode) return;
  try {
    
  class DriftWall extends HTMLElement {
    connectedCallback() {
      this.plane = this.querySelector('[data-dw-plane]');
      this.tracks = Array.from(this.querySelectorAll('[data-dw-track]'));
      if (!this.plane || !this.tracks.length) return;

      const num = (k, d) => {
        const v = parseFloat(this.dataset[k]);
        return Number.isFinite(v) ? v : d;
      };
      this.speed = num('speed', 42);
      this.tilt = num('tilt', 16);
      this.turn = num('turn', -14);
      this.depth = num('depth', 120);
      this.parallax = num('parallax', 0.6);
      this.variance = num('variance', 0.45);

      const baseCopies = Math.max(2, Math.round(num('copies', 2)));
      this.copies = this.tracks.map(() => baseCopies);

      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.desktop = window.matchMedia('(min-width: 750px)').matches;

      this.offsets = this.tracks.map(() => 0);
      this.vel = this.tracks.map(() => 0);
      this.wrap = this.tracks.map(() => 1);
      this.seeded = false;
      this.targetX = 0;
      this.targetY = 0;
      this.curX = 0;
      this.curY = 0;
      this.last = null;
      this.raf = null;

      this.onMove = this.onMove.bind(this);
      this.onLeave = this.onLeave.bind(this);
      this.tick = this.tick.bind(this);
      this.measure = this.measure.bind(this);

      this.measure();
      this.applyPlane();

      if (document.readyState !== 'complete') {
        window.addEventListener('load', this.measure, { once: true });
      }

      this.io = new IntersectionObserver(
        entries => {
          if (entries[0].isIntersecting) this.start();
          else this.stop();
        },
        { rootMargin: '150px' }
      );
      this.io.observe(this);

      if (this.desktop && this.parallax > 0 && !this.reduced) {
        this.addEventListener('pointermove', this.onMove);
        this.addEventListener('pointerleave', this.onLeave);
      }

      this.ro = new ResizeObserver(this.measure);
      this.ro.observe(this);
    }

    disconnectedCallback() {
      this.stop();
      if (this.io) this.io.disconnect();
      if (this.ro) this.ro.disconnect();
      window.removeEventListener('load', this.measure);
      this.removeEventListener('pointermove', this.onMove);
      this.removeEventListener('pointerleave', this.onLeave);
    }

    // Wrap into (-w/2, w/2] rather than [0, w). The strip is centred on the
    // section, so symmetric travel leaves half a period of spare content above
    // AND below the frame at all times. Wrapping into [0, w) instead spends
    // the back half of every cycle with the end of the strip inside the frame,
    // which is what made tiles vanish from a column and return seconds later.
    static fold(v, w) {
      let x = ((v % w) + w) % w;
      if (x > w / 2) x -= w;
      return x;
    }

    // Distance from the first tile of one copy to the first tile of the next.
    // scrollHeight / copies is short by part of a gap and makes the wrap jump.
    periodOf(track, perCopy) {
      const kids = track.children;
      if (!kids[0] || !kids[perCopy]) return 0;
      return kids[perCopy].offsetTop - kids[0].offsetTop;
    }

    measure() {
      this.desktop = window.matchMedia('(min-width: 750px)').matches;

      // The tilted plane shows a taller slice than the section is; 1.4 covers
      // it with room to spare.
      const need = this.offsetHeight * 1.4;

      this.tracks.forEach((track, i) => {
        let copies = this.copies[i];
        const perCopy = Math.max(1, Math.round(track.children.length / copies));
        let period = this.periodOf(track, perCopy);

        // Safety net: if the rendered strip is shorter than the Liquid
        // estimate assumed (a thin collection, products without images, a
        // setting changed in the editor), clone another copy until it covers.
        let guard = 0;
        while (period > 0 && track.offsetHeight - period < need && guard < 4) {
          const frag = document.createDocumentFragment();
          for (let k = 0; k < perCopy; k++) {
            frag.appendChild(track.children[k].cloneNode(true));
          }
          track.appendChild(frag);
          copies += 1;
          guard += 1;
          period = this.periodOf(track, perCopy);
        }

        this.copies[i] = copies;
        this.wrap[i] = period > 0 ? period : Math.max(1, track.scrollHeight / copies);

        const seed = this.seeded ? this.offsets[i] : this.wrap[i] * ((i * 0.37) % 1);
        this.offsets[i] = DriftWall.fold(seed, this.wrap[i]);
      });

      this.seeded = true;
    }

    factor(i) {
      const p = ((i * 0.618033988749 + 0.35) % 1) * 2 - 1;
      const alt = i % 2 === 0 ? 1 : -1;
      return (1 + this.variance * p) * alt;
    }

    applyPlane() {
      const t = this.desktop ? this.tilt : this.tilt * 0.5;
      const y = this.desktop ? this.turn : this.turn * 0.5;
      const scale = this.desktop ? 1.18 : 1.05;
      const depth = this.desktop ? this.depth : this.depth * 0.5;
      this.plane.style.transform =
        'translate(-50%, -50%) scale(' +
        scale +
        ') rotateX(' +
        (t + this.curY) +
        'deg) rotateY(' +
        (y + this.curX) +
        'deg) translateZ(' +
        -depth +
        'px)';
    }

    onMove(e) {
      const r = this.getBoundingClientRect();
      const max = this.parallax * 8;
      this.targetX = ((e.clientX - r.left) / r.width - 0.5) * max;
      this.targetY = -((e.clientY - r.top) / r.height - 0.5) * max;
    }

    onLeave() {
      this.targetX = 0;
      this.targetY = 0;
    }

    start() {
      if (this.raf) return;
      this.last = null;
      this.raf = requestAnimationFrame(this.tick);
    }

    stop() {
      if (!this.raf) return;
      cancelAnimationFrame(this.raf);
      this.raf = null;
    }

    tick(ts) {
      if (this.last === null) this.last = ts;
      const dt = Math.min(0.05, Math.max(0, ts - this.last) / 1000);
      this.last = ts;

      const damp = 1 - Math.exp(-dt / 0.12);
      this.curX += (this.targetX - this.curX) * damp;
      this.curY += (this.targetY - this.curY) * damp;
      this.applyPlane();

      if (!this.reduced) {
        for (let i = 0; i < this.tracks.length; i++) {
          const target = this.speed * this.factor(i);
          const ease = 1 - Math.exp(-dt / 0.28);
          this.vel[i] += (target - this.vel[i]) * ease;
          const next = DriftWall.fold(this.offsets[i] + this.vel[i] * dt, this.wrap[i]);
          this.offsets[i] = next;
          this.tracks[i].style.transform = 'translate3d(0,' + -next + 'px,0)';
        }
      }

      this.raf = requestAnimationFrame(this.tick);
    }
  }

  if (!customElements.get('drift-wall')) {
    customElements.define('drift-wall', DriftWall);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-today"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('featured-today')) return;

    class FeaturedToday extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.track = this.querySelector('.ft__track');
        this.prevBtn = this.querySelector('[data-ft-prev]');
        this.nextBtn = this.querySelector('[data-ft-next]');
        if (!this.track) return;

        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.onScroll = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => {
            this.raf = 0;
            this.update();
          });
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.ro = new ResizeObserver(this.onScroll);
        this.ro.observe(this.track);

        this.prevBtn?.addEventListener('click', () => this.page(-1));
        this.nextBtn?.addEventListener('click', () => this.page(1));

        this.stillCardSlideshows();
        this.initDrag();
        this.update();
        document.fonts?.ready.then(() => {
          this.base = undefined;
          this.update();
        });
      }

      disconnectedCallback() {
        this.ro?.disconnect();
      }

      /* Width of one card plus the gap: the distance between two snap
         points. */
      step() {
        const items = this.track.querySelectorAll('.ft__item');
        if (items.length > 1) return items[1].offsetLeft - items[0].offsetLeft;
        return this.track.clientWidth;
      }

      /* Arrows move by the cards that are fully on screen. */
      page(dir) {
        const step = this.step();
        const pad = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
        const whole = Math.max(1, Math.floor((this.track.clientWidth - pad) / step));
        this.track.scrollBy({ left: dir * whole * step, behavior: this.reduced ? 'auto' : 'smooth' });
      }

      update() {
        const t = this.track;
        const max = t.scrollWidth - t.clientWidth;
        const ratio = t.scrollWidth > 0 ? Math.min(1, t.clientWidth / t.scrollWidth) : 1;
        const pos = max > 0 ? Math.min(1, Math.max(0, t.scrollLeft / max)) : 0;
        this.style.setProperty('--ft-thumb', ratio.toFixed(4));
        this.style.setProperty('--ft-pos', pos.toFixed(4));
        if (this.prevBtn) this.prevBtn.disabled = t.scrollLeft <= 2;
        if (this.nextBtn) this.nextBtn.disabled = t.scrollLeft >= max - 2;
        this.toggleAttribute('data-static', max <= 2);
        this.liftLine();
      }

      /* Lift the progress line by the empty space under the cards on screen
         (see the note on .ft__foot). Only cards at least partly visible
         count; the lowest bit of text among them is the reference. */
      liftLine() {
        const tb = this.track.getBoundingClientRect();
        let lowest = -Infinity;
        for (const li of this.track.children) {
          const r = li.getBoundingClientRect();
          if (r.right <= tb.left || r.left >= tb.right) continue;
          const card = li.querySelector('.product-grid__card') || li;
          for (const el of card.children) {
            const b = el.getBoundingClientRect();
            if (b.height > 0 && b.bottom > lowest) lowest = b.bottom;
          }
        }
        const lift = Number.isFinite(lowest) ? Math.max(0, Math.round(tb.bottom - lowest)) : 0;
        if (lift !== this.lift) {
          this.lift = lift;
          this.style.setProperty('--ft-line-lift', `${lift}px`);
        }
        /* The lift at load (and after a resize or the web fonts arriving)
           becomes part of the layout; see the note on .ft__foot. */
        const w = this.track.clientWidth;
        if (this.base === undefined || w !== this.baseWidth) {
          this.base = lift;
          this.baseWidth = w;
          this.style.setProperty('--ft-line-base', `${lift}px`);
        }
      }

      /* A card with several photos is a small slideshow of its own. Inside a
         row that scrolls sideways, a swipe on the photo would flip the photo
         instead of moving the row, so those slideshows are switched off here
         (Horizon does the same for cards in its own carousels). */
      stillCardSlideshows() {
        this.track.querySelectorAll('slideshow-component').forEach((el) => el.setAttribute('disabled', 'true'));
      }

      /* A mouse can drag the row. Touch and trackpads scroll it natively and
         are left alone. A drag longer than a few pixels does not count as a
         click on the card under the pointer. */
      initDrag() {
        const t = this.track;
        let id = null;
        let startX = 0;
        let startLeft = 0;
        let moved = false;

        t.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          id = e.pointerId;
          startX = e.clientX;
          startLeft = t.scrollLeft;
          moved = false;
        });

        t.addEventListener('pointermove', (e) => {
          if (e.pointerId !== id) return;
          const dx = e.clientX - startX;
          if (!moved && Math.abs(dx) > 6) {
            moved = true;
            this.classList.add('is-dragging');
            try {
              t.setPointerCapture(id);
            } catch (err) {}
          }
          if (moved) t.scrollLeft = startLeft - dx;
        });

        const end = (e) => {
          if (e.pointerId !== id) return;
          id = null;
          if (!moved) return;
          this.classList.remove('is-dragging');
          this.swallowClick = true;
          setTimeout(() => (this.swallowClick = false), 0);
          /* Land on the nearest card, as a swipe would. */
          const step = this.step();
          const target = Math.round(t.scrollLeft / step) * step;
          t.scrollTo({ left: target, behavior: this.reduced ? 'auto' : 'smooth' });
        };
        t.addEventListener('pointerup', end);
        t.addEventListener('pointercancel', end);

        t.addEventListener(
          'click',
          (e) => {
            if (!this.swallowClick) return;
            e.preventDefault();
            e.stopPropagation();
          },
          true
        );
        t.addEventListener('dragstart', (e) => e.preventDefault());
      }
    }

    customElements.define('featured-today', FeaturedToday);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["request-item"] && !Shopify.designMode) return;
  try {
    
  class RequestItem extends HTMLElement {
    connectedCallback() {
      this.fields = this.querySelector('.rqi__fields');
      this.fieldInputs = Array.from(this.querySelectorAll('.rqi__fields input, .rqi__fields textarea, .rqi__fields select'));
      this.sizeField = this.querySelector('.rqi__field--size');
      this.radios = Array.from(this.querySelectorAll('.rqi__cat-input'));
      this.brand = this.querySelector('.rqi__input--brand');
      this.brandError = this.querySelector('.rqi__error');
      this.form = this.closest('form');

      // Accents folded once, so "hermes" matches "Hermès".
      this.blocked = (this.dataset.blocked || '')
        .split(',')
        .map((name) => RequestItem.fold(name))
        .filter(Boolean);

      if (this.radios.length) {
        this.radios.forEach((radio) => {
          radio.addEventListener('change', () => this.pick(true));
        });
        // Only now: without the script the whole form has to stay reachable.
        this.pick(false);
      }

      if (this.brand) {
        this.brand.addEventListener('input', () => this.checkBrand(false));
        this.brand.addEventListener('blur', () => this.checkBrand(true));
      }

      if (this.form) {
        this.form.addEventListener('submit', (event) => {
          if (this.checkBrand(true)) return;
          event.preventDefault();
          this.brand.focus();
        });
      }
    }

    static fold(value) {
      return (value || '')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .trim();
    }

    get chosen() {
      return this.radios.find((radio) => radio.checked) || null;
    }

    // `move` is false on the first pass, so a page restored by the back button
    // does not jump on its own.
    pick(move) {
      const chosen = this.chosen;
      const locked = !chosen;

      if (this.fields) {
        if (this.dataset.stepMode === 'hidden') {
          this.fields.hidden = locked;
          this.fields.classList.remove('is-locked');
        } else {
          this.fields.hidden = false;
          this.fields.classList.toggle('is-locked', locked);
        }
        // Disabled, not just dimmed: nothing tabbable and nothing submitted
        // while step 1 is open.
        this.fieldInputs.forEach((el) => {
          el.disabled = locked;
        });
      }

      this.classList.toggle('is-step-2', !locked);

      if (this.sizeField) {
        this.sizeField.hidden = !chosen || chosen.dataset.size !== 'true';
        const input = this.sizeField.querySelector('input');
        // A hidden field must not travel with the mail.
        if (input) input.disabled = this.sizeField.hidden;
      }

      // Only worth a nudge when step 2 was not on screen a moment ago. In
      // "locked" mode it already is, and scrolling on click just moves the
      // page under the reader.
      if (move && chosen && this.fields && this.dataset.stepMode === 'hidden') {
        this.fields.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    // Returns true when the brand is fine.
    checkBrand(show) {
      if (!this.brand || !this.brandError) return true;

      const typed = RequestItem.fold(this.brand.value);
      const hit = typed !== '' && this.blocked.some((name) => typed.includes(name));

      if (hit && show) {
        this.brandError.textContent = this.dataset.blockedMessage || '';
        this.brandError.hidden = false;
        this.brand.setAttribute('aria-invalid', 'true');
      } else if (!hit) {
        this.brandError.hidden = true;
        this.brandError.textContent = '';
        this.brand.removeAttribute('aria-invalid');
      }

      return !hit;
    }
  }

  if (!customElements.get('request-item')) {
    customElements.define('request-item', RequestItem);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spotlight-cards"] && !Shopify.designMode) return;
  try {
    
  class SpotlightCards extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.spc__card'));

      if (this.dataset.equalHeight === 'true') this.matchHeights();

      // Pointer-driven only. On touch there is no hover state to speak of and a
      // stuck highlight after a tap looks like a rendering bug.
      if (!window.matchMedia('(hover: hover)').matches) return;

      this.addEventListener('pointermove', (event) => {
        if (event.pointerType === 'touch') return;

        const card = event.target.closest('.spc__card');
        if (!card || !this.contains(card)) return;

        const rect = card.getBoundingClientRect();
        card.style.setProperty('--spc-x', event.clientX - rect.left + 'px');
        card.style.setProperty('--spc-y', event.clientY - rect.top + 'px');
      });
    }

    disconnectedCallback() {
      if (this.widthObserver) this.widthObserver.disconnect();
      cancelAnimationFrame(this.frame);
    }

    // Cards wrap onto separate flex lines, and each line sizes itself: three
    // short cards on the first line end up shorter than two long ones on the
    // second. No flex or grid property equalises across lines while still
    // centring a short last row, so it takes a measurement.
    //
    // This runs at every width, stacked cards included: a column of cards that
    // all end at the same place reads as a deliberate set, where cards of five
    // different heights read as five separate things. The spare space falls
    // under the shorter texts.
    matchHeights() {
      if (this.cards.length < 2) return;

      const apply = () => {
        this.cards.forEach((card) => {
          card.style.minHeight = '';
        });

        const tallest = this.cards.reduce((max, card) => Math.max(max, card.getBoundingClientRect().height), 0);
        this.cards.forEach((card) => {
          card.style.minHeight = `${Math.ceil(tallest)}px`;
        });
      };

      apply();

      // Text reflows when the real font arrives, which changes the answer.
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(apply);

      // Width only. Watching height here would be a loop: setting minHeight
      // changes the height, which fires the observer, which measures again.
      let lastWidth = 0;
      this.widthObserver = new ResizeObserver((entries) => {
        const width = Math.round(entries[0].contentRect.width);
        if (width === lastWidth) return;
        lastWidth = width;
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(apply);
      });
      this.widthObserver.observe(this);
    }
  }

  if (!customElements.get('spotlight-cards')) {
    customElements.define('spotlight-cards', SpotlightCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-counter"] && !Shopify.designMode) return;
  try {
    
  class StatCounters extends HTMLElement {
    connectedCallback() {
      this.stats = Array.from(this.querySelectorAll('.stc__value')).map((el) => ({
        el,
        base: parseFloat(el.dataset.base) || 0,
        perDay: parseFloat(el.dataset.perDay) || 0,
        anchor: parseFloat(el.dataset.anchor) || 0,
        sep: el.dataset.sep || '',
        cols: null,
        digits: 0,
        shown: 0,
        printed: null,
      }));

      if (!this.stats.length) return;

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.rolling = this.dataset.style !== 'plain' && !reduced;
      this.counts = this.dataset.countUp === 'true' && !reduced;
      this.fromPct = (parseFloat(this.dataset.from) || 0) / 100;

      if (this.rolling) {
        this.stats.forEach((stat) => {
          this.buildReel(stat);
          // Park the wheels on the opening number so the final one never
          // flashes before the roll starts.
          const opening = this.counts ? Math.round(this.target(stat) * this.fromPct) : this.target(stat);
          stat.cols.forEach((col) => {
            col.pos = Math.floor(opening / col.place) % 10;
            this.paintCol(col);
          });
          // The written number is the truth from the first paint: the wheels are
          // decoration, and a screen reader should not be read a spinning value.
          this.print(stat, this.target(stat));
        });
      } else {
        this.stats.forEach((stat) => this.print(stat, this.counts ? Math.round(this.target(stat) * this.fromPct) : this.target(stat)));
      }

      if (!this.counts) {
        this.startTicking();
        return;
      }

      // Nothing happens until the row is actually on screen: a counter that has
      // already finished before you scroll to it is a counter you never see.
      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            obs.disconnect();
            this.start();
          });
        },
        { threshold: 0.35 }
      );

      observer.observe(this);
      this.observer = observer;
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      cancelAnimationFrame(this.frame);
      clearInterval(this.timer);
    }

    // base + whatever has accrued since the anchor date. Derived from the clock
    // rather than counted up locally, so a reload does not restart the growth
    // and two visitors see the same number.
    target(stat) {
      if (!stat.perDay || !stat.anchor) return Math.round(stat.base);
      const days = (Date.now() / 1000 - stat.anchor) / 86400;
      return Math.round(stat.base) + Math.max(0, Math.floor(days * stat.perDay));
    }

    buildReel(stat) {
      const host = stat.el.querySelector('.stc__num');
      if (!host) return;

      const text = String(this.target(stat));
      const reel = document.createElement('span');
      reel.className = 'stc__reel';
      reel.setAttribute('aria-hidden', 'true');

      const cols = [];

      for (let i = 0; i < text.length; i++) {
        const box = document.createElement('span');
        box.className = 'stc__digit';

        const col = document.createElement('span');
        col.className = 'stc__col';
        // 0-9 plus a repeated 0: when a wheel passes the last cell and jumps
        // back to the first, it lands on an identical glyph, so the wrap cannot
        // be seen and one transform drives the whole wheel.
        for (let d = 0; d <= 10; d++) {
          const cell = document.createElement('span');
          cell.textContent = String(d % 10);
          col.appendChild(cell);
        }

        box.appendChild(col);
        reel.appendChild(box);
        cols.push({ col, place: Math.pow(10, text.length - 1 - i), pos: 0 });

        const remaining = text.length - 1 - i;
        if (stat.sep && remaining > 0 && remaining % 3 === 0) {
          const sep = document.createElement('span');
          sep.className = 'stc__sep';
          sep.textContent = stat.sep;
          reel.appendChild(sep);
        }
      }

      if (stat.reel) stat.reel.remove();
      host.appendChild(reel);
      host.classList.add('stc__num--rolling');

      stat.reel = reel;
      stat.cols = cols;
      stat.digits = text.length;
    }

    paintCol(col) {
      col.col.style.setProperty('--p', (((col.pos % 10) + 10) % 10).toFixed(3));
    }

    print(stat, value) {
      const rounded = Math.round(value);
      if (stat.printed === rounded) return;
      stat.printed = rounded;

      const number = stat.el.querySelector('.stc__number');
      if (number) number.textContent = String(rounded).replace(/\B(?=(\d{3})+(?!\d))/g, stat.sep);
    }

    // Every wheel only ever turns forwards, by the shortest way round to the
    // digit it needs. `turns` adds whole extra revolutions, which is what makes
    // the opening count look like a wheel spinning up rather than a digit being
    // swapped; a later tick of +1 asks for none, so only the units wheel moves.
    plan(duration, turns) {
      const legs = [];

      this.stats.forEach((stat) => {
        const value = this.target(stat);
        if (String(value).length !== stat.digits) this.buildReel(stat);
        this.print(stat, value);

        const total = stat.cols.length;
        stat.cols.forEach((col, i) => {
          const digit = Math.floor(value / col.place) % 10;
          const step = (((digit - Math.round(col.pos)) % 10) + 10) % 10;
          // i counts from the left, so the units wheel on the right gets the
          // most revolutions - as it would on a real dial, where the last wheel
          // turns ten times for every turn of the one beside it.
          const extra = turns ? (turns + i) * 10 : 0;
          if (step === 0 && extra === 0) return;

          legs.push({
            col,
            from: col.pos,
            to: Math.round(col.pos) + step + extra,
            // The wheels on the left stop first, the way an odometer settles.
            duration: turns ? duration * (0.55 + (0.45 * (i + 1)) / total) : duration,
          });
        });
      });

      return legs;
    }

    roll(duration, turns, done) {
      const legs = this.plan(duration, turns);
      if (!legs.length) {
        if (done) done();
        return;
      }

      const began = performance.now();
      cancelAnimationFrame(this.frame);

      const step = (now) => {
        let running = false;

        for (let i = 0; i < legs.length; i++) {
          const leg = legs[i];
          const progress = Math.min(1, (now - began) / leg.duration);
          // Fast away, long settle: the spin should read as coming to rest.
          const eased = 1 - Math.pow(1 - progress, 3);
          leg.col.pos = progress === 1 ? leg.to : leg.from + (leg.to - leg.from) * eased;
          this.paintCol(leg.col);
          if (progress < 1) running = true;
        }

        if (running) {
          this.frame = requestAnimationFrame(step);
        } else if (done) {
          done();
        }
      };

      this.frame = requestAnimationFrame(step);
    }

    // The plain style has no wheels: one eased tween over the number itself.
    tween(duration, done) {
      const targets = this.stats.map((stat) => this.target(stat));
      const starts = this.stats.map((stat) => stat.shown);
      const began = performance.now();
      cancelAnimationFrame(this.frame);

      const step = (now) => {
        const progress = Math.min(1, (now - began) / duration);
        const eased =
          progress < 0.5
            ? 4 * progress * progress * progress
            : 1 - Math.pow(-2 * progress + 2, 3) / 2;

        this.stats.forEach((stat, i) => {
          stat.shown = progress === 1 ? targets[i] : starts[i] + (targets[i] - starts[i]) * eased;
          this.print(stat, stat.shown);
        });

        if (progress < 1) {
          this.frame = requestAnimationFrame(step);
        } else if (done) {
          done();
        }
      };

      this.frame = requestAnimationFrame(step);
    }

    start() {
      const duration = parseInt(this.dataset.duration, 10) || 2800;
      const finish = () => this.startTicking();

      if (this.rolling) {
        this.roll(duration, 2, finish);
      } else {
        this.stats.forEach((stat) => {
          stat.shown = Math.round(this.target(stat) * this.fromPct);
        });
        this.tween(duration, finish);
      }
    }

    // Only worth a timer if something actually grows. When it does the change is
    // rolled, not swapped: one order more looks like the wheel turning by one.
    startTicking() {
      this.stats.forEach((stat) => {
        stat.shown = this.target(stat);
      });

      if (!this.stats.some((stat) => stat.perDay > 0)) return;

      clearInterval(this.timer);
      this.timer = setInterval(() => {
        const moved = this.stats.some((stat) => this.target(stat) !== stat.printed);
        if (!moved) return;
        if (this.rolling) {
          this.roll(700, 0);
          this.stats.forEach((stat) => {
            stat.shown = this.target(stat);
          });
        } else {
          this.tween(700);
        }
      }, 1000);
    }
  }

  if (!customElements.get('stat-counters')) {
    customElements.define('stat-counters', StatCounters);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-hub"] && !Shopify.designMode) return;
  try {
    
  class SupportHub extends HTMLElement {
    connectedCallback() {
      this.chips = Array.from(this.querySelectorAll('.sup__chip'));
      this.groups = Array.from(this.querySelectorAll('.sup__group'));
      if (this.chips.length < 1 || this.groups.length < 1) return;

      // Only now do the groups start hiding each other. Until this class is on,
      // every group is visible with its own heading, which is what someone
      // without JavaScript gets - the whole page, readable, just not filtered.
      this.classList.add('sup__hub--ready');

      this.chips.forEach((chip) => {
        chip.addEventListener('click', () => this.select(chip.dataset.key));
        chip.addEventListener('keydown', (event) => this.onKey(event));
      });

      // A support answer is a thing people link to. #returns opens that topic.
      const fromHash = decodeURIComponent(window.location.hash.replace('#', ''));
      const wanted = this.groups.some((g) => g.dataset.key === fromHash) ? fromHash : this.chips[0].dataset.key;
      this.select(wanted, { focus: false, writeHash: false });
    }

    select(key, options) {
      const settings = options || {};
      let matched = false;

      this.chips.forEach((chip) => {
        const on = chip.dataset.key === key;
        if (on) matched = true;
        chip.setAttribute('aria-selected', on ? 'true' : 'false');
        chip.tabIndex = on ? 0 : -1;
        if (on && settings.focus) chip.focus({ preventScroll: true });
        // Instant on page load (deep link), smooth when someone taps.
        if (on) this.reveal(chip, settings.writeHash !== false);
      });

      if (!matched) return;

      // The form's Topic follows the chip, until someone picks one by hand.
      const topic = this.closest('.sup')?.querySelector('[data-sup-topic]');
      if (topic && !topic.dataset.touched) {
        const option = topic.querySelector(`option[data-key="${key}"]`);
        if (option) topic.value = option.value;
      }
      if (topic && !topic.dataset.bound) {
        topic.dataset.bound = 'true';
        topic.addEventListener('change', () => { topic.dataset.touched = 'true'; });
      }

      this.groups.forEach((group) => {
        const on = group.dataset.key === key;
        group.hidden = !on;
        // Leaving a topic with three answers hanging open means coming back to
        // a wall of text. Closing them makes every topic open the same way.
        if (!on) group.querySelectorAll('details[open]').forEach((row) => row.removeAttribute('open'));
      });

      // replaceState, not the hash directly: setting location.hash would jump
      // the page to the panel and throw away the reader's scroll position.
      if (settings.writeHash !== false && window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '#' + key);
      }
    }

    // On a phone the chips are one sliding row: bring the chosen one fully
    // into view. Sideways only - scrollIntoView would also scroll the page,
    // and on load the row sits below the aurora header.
    reveal(chip, smooth) {
      const row = chip.parentElement;
      if (!row || row.scrollWidth <= row.clientWidth + 1) return;
      const box = row.getBoundingClientRect();
      const rect = chip.getBoundingClientRect();
      const pad = parseFloat(getComputedStyle(row).scrollPaddingInlineStart) || 0;
      if (rect.left >= box.left + pad && rect.right <= box.right - pad) return;
      const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      row.scrollTo({
        left: row.scrollLeft + (rect.left - box.left) - pad,
        behavior: smooth && !still ? 'smooth' : 'auto',
      });
    }

    onKey(event) {
      const index = this.chips.indexOf(event.target);
      if (index < 0) return;

      let next = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % this.chips.length;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + this.chips.length) % this.chips.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = this.chips.length - 1;
      if (next === null) return;

      event.preventDefault();
      this.select(this.chips[next].dataset.key, { focus: true });
    }
  }

  if (!customElements.get('support-hub')) {
    customElements.define('support-hub', SupportHub);
  }

  /* Aurora header. The shader is the one in sections/aurora-404.liquid; it is
     copied rather than shared so a change to one page cannot break the other.
     Wrapped in its own scope: section scripts can end up in one bundle, and two
     top-level consts with the same name would take the whole bundle down. */
  (() => {
    const VERT = `#version 300 es
    in vec2 aPos;
    void main() { gl_Position = vec4(aPos, 0.0, 1.0); }`;

    const FRAG = `#version 300 es
    precision highp float;
    uniform float uTime;
    uniform vec2 uRes;
    uniform vec3 uC0;
    uniform vec3 uC1;
    uniform vec3 uC2;
    uniform float uBlend;
    uniform float uAmp;
    uniform float uFreq;
    out vec4 fragColor;

    float band(float x, float t) {
      float v = 0.0;
      v += sin(x * 2.1 + t * 0.70) * 0.50;
      v += sin(x * 3.7 - t * 0.45) * 0.30;
      v += sin(x * 6.3 + t * 1.10) * 0.15;
      v += sin(x * 9.1 - t * 0.80) * 0.08;
      return v;
    }

    void main() {
      vec2 uv = gl_FragCoord.xy / uRes;

      vec3 ramp = uv.x < 0.5
        ? mix(uC0, uC1, uv.x * 2.0)
        : mix(uC1, uC2, (uv.x - 0.5) * 2.0);

      float h = band(uv.x * uFreq, uTime) * 0.25 * uAmp;
      h = exp(h);

      float f = uv.y * 2.0 - h + 0.2;
      float intensity = 0.6 * f;

      float mid = 0.20;
      float a = smoothstep(mid - uBlend * 0.5, mid + uBlend * 0.5, intensity);

      fragColor = vec4(ramp * clamp(intensity, 0.0, 1.4), a);
    }`;

    class SupportAurora extends HTMLElement {
      connectedCallback() {
        this.host = this.querySelector('[data-aurora-canvas]');
        if (!this.host) return;

        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.mq = window.matchMedia('(max-width: 749px)');

        this.speed = this.num('speed', 1.5);
        this.blend = this.num('blend', 0.7);
        this.amp = this.num('amp', 1);
        this.ampMobile = this.num('ampMobile', 0.6);

        this.tick = this.tick.bind(this);
        this.resize = this.resize.bind(this);

        if (!this.init()) return;

        this.setAttribute('data-gl', 'on');
        this.resize();
        this.ro = new ResizeObserver(this.resize);
        this.ro.observe(this);

        // Reduced motion gets one still frame, not a blank header.
        this.draw(0);
        if (this.reduced) return;

        // Only animate while on screen - the header scrolls away quickly here.
        this.io = new IntersectionObserver(
          (entries) => (entries[0].isIntersecting ? this.start() : this.stop()),
          { rootMargin: '100px' }
        );
        this.io.observe(this);
      }

      disconnectedCallback() {
        this.stop();
        if (this.io) this.io.disconnect();
        if (this.ro) this.ro.disconnect();
        if (this.gl) {
          const ext = this.gl.getExtension('WEBGL_lose_context');
          if (ext) ext.loseContext();
        }
      }

      num(key, fallback) {
        const v = parseFloat(this.dataset[key]);
        return Number.isFinite(v) ? v : fallback;
      }

      currentAmp() {
        return this.mq.matches ? this.ampMobile : this.amp;
      }

      // The wave runs across the width. On a narrow screen the same number of
      // waves squeezes into less room and reads as stretched upright, so scale
      // the frequency by the shape of the header (always on here; a setting on
      // the 404 that is also on there).
      currentFreq() {
        const w = this.canvas ? this.canvas.width : 1;
        const h = this.canvas ? this.canvas.height : 1;
        const aspect = w / Math.max(1, h);
        return 3.0 * Math.min(1.4, Math.max(0.45, aspect / 2.3));
      }

      compile(gl, type, src) {
        const sh = gl.createShader(type);
        gl.shaderSource(sh, src);
        gl.compileShader(sh);
        if (!gl.getShaderParameter(sh, gl.COMPILE_STATUS)) {
          console.warn('[support-aurora] shader failed:', gl.getShaderInfoLog(sh));
          return null;
        }
        return sh;
      }

      init() {
        const canvas = document.createElement('canvas');
        const gl = canvas.getContext('webgl2', { alpha: true, antialias: true, premultipliedAlpha: false });
        if (!gl) return false;

        const vs = this.compile(gl, gl.VERTEX_SHADER, VERT);
        const fs = this.compile(gl, gl.FRAGMENT_SHADER, FRAG);
        if (!vs || !fs) return false;

        const prog = gl.createProgram();
        gl.attachShader(prog, vs);
        gl.attachShader(prog, fs);
        gl.linkProgram(prog);
        if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) {
          console.warn('[support-aurora] link failed:', gl.getProgramInfoLog(prog));
          return false;
        }
        gl.useProgram(prog);

        const buf = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, buf);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
        const loc = gl.getAttribLocation(prog, 'aPos');
        gl.enableVertexAttribArray(loc);
        gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);

        gl.enable(gl.BLEND);
        gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
        gl.clearColor(0, 0, 0, 0);

        this.u = {
          time: gl.getUniformLocation(prog, 'uTime'),
          res: gl.getUniformLocation(prog, 'uRes'),
          c0: gl.getUniformLocation(prog, 'uC0'),
          c1: gl.getUniformLocation(prog, 'uC1'),
          c2: gl.getUniformLocation(prog, 'uC2'),
          blend: gl.getUniformLocation(prog, 'uBlend'),
          amp: gl.getUniformLocation(prog, 'uAmp'),
          freq: gl.getUniformLocation(prog, 'uFreq'),
        };

        gl.uniform3fv(this.u.c0, this.hex(this.dataset.c0, 'f43f5e'));
        gl.uniform3fv(this.u.c1, this.hex(this.dataset.c1, 'f97316'));
        gl.uniform3fv(this.u.c2, this.hex(this.dataset.c2, '5227ff'));
        gl.uniform1f(this.u.blend, this.blend);
        gl.uniform1f(this.u.amp, this.currentAmp());
        gl.uniform1f(this.u.freq, 3.0);

        this.canvas = canvas;
        this.gl = gl;
        this.host.appendChild(canvas);
        return true;
      }

      hex(v, fallback) {
        let h = (v || '').trim().replace('#', '');
        if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
        if (!/^[0-9a-fA-F]{6}$/.test(h)) h = fallback;
        const n = parseInt(h, 16);
        return [((n >> 16) & 255) / 255, ((n >> 8) & 255) / 255, (n & 255) / 255];
      }

      resize() {
        if (!this.gl) return;
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        const w = Math.max(1, Math.round(this.offsetWidth * dpr));
        const h = Math.max(1, Math.round(this.offsetHeight * dpr));
        if (this.canvas.width === w && this.canvas.height === h) return;
        this.canvas.width = w;
        this.canvas.height = h;
        this.gl.viewport(0, 0, w, h);
        this.gl.uniform2f(this.u.res, w, h);
        this.gl.uniform1f(this.u.amp, this.currentAmp());
        this.gl.uniform1f(this.u.freq, this.currentFreq());
        this.draw(this.lastT || 0);
      }

      draw(t) {
        const gl = this.gl;
        if (!gl) return;
        this.lastT = t;
        gl.uniform1f(this.u.time, t);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.drawArrays(gl.TRIANGLES, 0, 3);
      }

      start() {
        if (this.raf) return;
        // Carry on from where it stopped instead of jumping back to frame 0.
        const carried = this.speed > 0 ? ((this.lastT || 0) / this.speed) * 1000 : 0;
        this.t0 = performance.now() - carried;
        this.raf = requestAnimationFrame(this.tick);
      }

      stop() {
        if (!this.raf) return;
        cancelAnimationFrame(this.raf);
        this.raf = null;
      }

      tick(now) {
        this.draw(((now - this.t0) / 1000) * this.speed);
        this.raf = requestAnimationFrame(this.tick);
      }
    }

    if (!customElements.get('support-aurora')) {
      customElements.define('support-aurora', SupportAurora);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
